export const gongcai = [
  {
    "id": 1802,
    "name": "商家管理",
    "component": "Layout",
    "path": "",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131624554473.svg",
    "layout": "1",
    "router_name": "weishopapplication",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": [
      {
        "id": 1803,
        "name": "商家列表",
        "component": "apps/weishop/shop/application/supplier/user.vue",
        "path": "/weishop/shop/application/supplier/user",
        "icon": "",
        "layout": "1",
        "router_name": "weishopapplication",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 1804,
        "name": "分组管理",
        "component": "apps/weishop/shop/application/supplier/group.vue",
        "path": "/weishop/shop/application/supplier/group",
        "icon": "",
        "layout": "1",
        "router_name": "weishopapplication",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 1805,
        "name": "新增供应商",
        "component": "apps/weishop/shop/application/supplier/user_add.vue",
        "path": "/weishop/shop/application/supplier/user_add",
        "icon": "",
        "layout": "2",
        "router_name": "weishopapplication",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      }
    ]
  },
  {
    "id": 1806,
    "name": "订单管理",
    "component": "Layout",
    "path": "",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131625109822.svg",
    "layout": "1",
    "router_name": "weishopapplication",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": [
      {
        "id": 1807,
        "name": "订单管理",
        "component": "apps/weishop/shop/application/supplier/order.vue",
        "path": "/weishop/shop/application/supplier/order",
        "icon": "",
        "layout": "1",
        "router_name": "weishopapplication",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 1808,
        "name": "售后订单",
        "component": "apps/weishop/shop/application/supplier/sales.vue",
        "path": "/weishop/shop/application/supplier/sales",
        "icon": "",
        "layout": "1",
        "router_name": "weishopapplication",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      }
    ]
  },
  {
    "id": 1809,
    "name": "结算管理",
    "component": "apps/weishop/shop/application/supplier/bill.vue",
    "path": "/weishop/shop/application/supplier/bill",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251204/202512040909005563.svg",
    "layout": "1",
    "router_name": "weishopapplication",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  },
  {
    "id": 1810,
    "name": "基础设置",
    "component": "apps/weishop/shop/application/supplier/set.vue",
    "path": "/weishop/shop/application/supplier/set",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251204/202512040909005563.svg",
    "layout": "1",
    "router_name": "weishopapplication",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  }
];
